import React from 'react'
import UpdatePurposeForm from '../../../component/form/master/purpose/UpdatePurposeForm'

export default function UpdatePurpose() {
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <UpdatePurposeForm />
                    </div>
                </div>
            </div>
        </>
    )
}


